import { Inject, Injectable } from '@angular/core';
import { AnalyticInterface, CustomWindow } from './analytics.service';
import { DOCUMENT } from '@angular/common';
import { Product } from '../models/api.models';
import { OrderResponse } from '../models/api-responses';

declare var Ya: {
  Metrika2: any
};

export interface CounterConfig {
  id: string | number;
  params?: any;
  clickmap?: boolean;
  trackLinks?: boolean;
  accurateTrackBounce?: boolean;
  webvisor?: boolean;
  trackHash?: boolean;
  ut?: string;
  ecommerce?: string;
  triggerEvent?: boolean;
  alternative?: boolean;
}

export class YandexCounterConfig implements CounterConfig {
  id: string | number;
  params: any;
  clickmap = true;
  trackLinks = true;
  accurateTrackBounce = true;
  webvisor = false;
  trackHash = true;
  ut = 'noindex';
  ecommerce?: string;
  triggerEvent?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsYandexMetrikaService implements AnalyticInterface {

  constructor(
    @Inject(Window) private window: CustomWindow,
    @Inject(DOCUMENT) private document: Document,
  ) {

  }

  private static getCounterNameById(id: string | number): string {
    return `yaCounter${id}`;
  }

  init(config: YandexCounterConfig): void {
    this.window.dataLayer = this.window.dataLayer || [];
    this.window.yandex_metrika_callbacks2 = this.window.yandex_metrika_callbacks2 || [];
    this.window.yandex_metrika_callbacks2.push(() => {
      try {
        this.createCounter(config);
      } catch (e) {
        console.error(e);
      }
    });

    const n = this.document.getElementsByTagName('script')[0];
    const s = this.document.createElement('script');
    s.id = 'geco-metric';
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://mc.yandex.ru/metrika/tag.js';

    if (n && n.parentNode) {
      const insetScriptTag = () => n.parentNode?.insertBefore(s, n);

      if ((this.window as any).opera === '[object Opera]') {
        this.document.addEventListener('DOMContentLoaded', insetScriptTag, false);
      } else {
        insetScriptTag();
      }
    }
  }

  productShow(product: Product): boolean {
    this.window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        detail: {
          products: [
            {
              id: product.id,
              name: product.name,
              price: product.productGroupInfo,
              // brand: 'Яндекс / Яndex',
              // category: 'Одежда/Мужская одежда/Футболки',
              // variant: 'Красный цвет'
            }
          ]
        }
      }
    });
    return true;
  }

  orderPlaced(order: OrderResponse): boolean {
    this.window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            id: order.id
          },
          products: order.orderProducts.map(orderProduct => {
            return {
              id: orderProduct.id,
              name: orderProduct.product.name,
              price: orderProduct.price,
              brand: '',
              category: 'todo fix', // orderProduct.product.productGroupInfo.name,
              variant: '',
              quantity: orderProduct.quantity
            };
          })
        }
      }
    });
    return true;
  }

  private createCounter(config: YandexCounterConfig): void {
    this.window[AnalyticsYandexMetrikaService.getCounterNameById(config.id)] = new Ya.Metrika2(config);
  }
}
